import { useState } from 'react';
import { TransitionView } from '../../../../types'

export const useTransitionView = (initialView: TransitionView = 'idle') => {
  const [mode, setMode] = useState<TransitionView>(initialView);

  const actions = {
    setCreating: () => setMode('creating'),
    setEditing: () => setMode('editing'),
    setViewing: () => setMode('viewing'),
    setIdle: () => setMode('idle'),

    isIdle: mode === 'idle',
    isViewing: mode === 'viewing',
    isCreating: mode === 'creating',
    isEditing: mode === 'editing',
    isPayeeForm: mode === 'creating' || mode === 'editing' || mode === 'viewing',
  };

  return {
    mode,
    ...actions
  } as const;
};
